export default {
    listagem: {
        titulo_pagina: 'Component List',
        novo: 'Create New Component',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Component Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Component',
            editar: 'Edit Component'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Component Code'
            },
            nome: {
                label: 'Name',
                description: 'Component Name'
            },
            status: {
                label: 'Status',
                description: 'Component active or inactive status'
            },
            botao_salvar : 'Save Component'
        },
        create: {
            success: 'Component successfully created!',
            error: 'Error creating Component!'
        },
        update: {
            success: 'Component successfully edited!',
            error: 'Error editing Component!'
        }
    }
}
